import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { IMAGES } from "@/data/content";

const reveal = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0 },
};

export const About = () => {
  const { t } = useLang();

  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[#050507] py-24 md:py-32 lg:py-40"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <motion.div
          variants={reveal}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="relative"
        >
          <div className="relative overflow-hidden rounded-xl border border-white/10">
            <img
              src={IMAGES.aboutCar}
              alt="Fiat 500 Giannini progettata da InovoDesign"
              data-testid="about-feature-image"
              className="h-[420px] w-full object-cover object-center"
            />
          </div>
        </motion.div>

        <motion.div
          variants={reveal}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.1 }}
        >
          <p className="font-mono text-xs tracking-[0.2em] uppercase font-bold text-zinc-500">
            {t.about.overline}
          </p>
          <h2 className="mt-5 font-heading text-3xl sm:text-4xl tracking-tight font-medium text-white">
            {t.about.title}
          </h2>
          <p className="mt-6 text-base leading-relaxed text-zinc-400">
            {t.about.p1}
          </p>
          <p className="mt-4 text-base leading-relaxed text-zinc-400">
            {t.about.p2}
          </p>

          <div className="mt-10 grid sm:grid-cols-3 gap-px bg-white/5 rounded-lg overflow-hidden border border-white/5">
            {t.about.pillars.map((p) => (
              <div key={p.k} className="bg-[#0A0A0E] p-5">
                <div className="font-heading text-lg font-medium text-white">
                  {p.k}
                </div>
                <div className="mt-1 text-xs text-zinc-500 leading-snug">
                  {p.v}
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
